// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1p2DU","box":"WorkspacesBox_box__2OX4K","node":"WorkspacesBox_node__2vDRS"};